import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const neon: gsapTimelineFunc = (targets) => {
  return gsap
    .timeline({ defaults: { ease: Power1.easeOut } })
    .fromTo(targets, { duration: 0, opacity: 0 }, { duration: 0.1, opacity: 0 })
    .to(targets, { duration: 0.05, opacity: 1 })
    .to(targets, { duration: 0.1, opacity: 0 })
    .to(targets, { duration: 0.05, opacity: 1 })
    .to(targets, { duration: 0.1, opacity: 1 })
    .to(targets, { duration: 0.2, opacity: 0 })
    .to(targets, { duration: 0.03, opacity: 1 })
    .to(targets, { duration: 0.03, opacity: 0 })
    .to(targets, { duration: 0.03, opacity: 0 })
    .to(targets, { duration: 0.01, opacity: 1 })
    .to(targets, { duration: 0.2, opacity: 0 })
    .to(targets, { duration: 0.1, opacity: 1 });
};
